import { useState } from "react";
import Card from "../Card";
import PercentChange from "../PercentChange";
import YourAccountsModal from "./YourAccountsModal";
import { useSelector } from "react-redux";
import EmptyNewCryptoAccounts from "../../../components/Empty/EmptyNewCryptoAccounts";
import { formatCryptoValue } from "../../utils/format";

const YourAccounts = ({ className = "" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cryptoAccounts = useSelector((state) => state.client.clientInfo.crypto_accounts) ?? [];

  return (
    <>
      <Card className={`flex h-full flex-col overflow-hidden p-0 ${className}`}>
        <div className="flex h-[54px] shrink-0 items-center justify-between border-b border-divider px-4 pb-[17px] pt-4">
          <h2 className="text-base font-semibold leading-[21px] text-text-primary">
            Your Assets ({cryptoAccounts?.length})
          </h2>
        </div>

        <ul className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          {cryptoAccounts?.length === 0 ?             
            <EmptyNewCryptoAccounts />
            : 
            cryptoAccounts.map((account, index) => (
              <li
                key={account.id}
                className={`flex min-h-[78px] items-center justify-between px-5 pt-3 ${
                  index < cryptoAccounts?.length - 1
                    ? "border-b border-divider pb-3"
                    : "pb-0"
                }`}
              >
                <div className="flex min-w-0 items-center gap-3">
                  <div
                    className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full"
                    style={account.iconBg ? { backgroundColor: account.iconBg } : undefined}
                  >
                    <img
                      src={account.logo}
                      alt={account.title}
                      className="size-9 rounded-full object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className={`whitespace-nowrap text-text-primary ${
                        account.currency_code === "USDT"
                          ? "text-base font-medium leading-[19.5px]"
                          : "text-sm font-semibold leading-[19.5px]"
                      }`}
                    >
                      {account.currency_code}
                    </p>

                    <p className="whitespace-nowrap text-xs font-normal leading-[16.5px] text-text-secondary">
                      {account.title}
                    </p>
                  </div>
                </div>

                <div className="flex shrink-0 flex-col items-end">
                  <p className="whitespace-nowrap text-sm font-medium leading-[19.5px] text-text-primary">
                    {/* {account.balance} {account.currency_code} */}
                    {formatCryptoValue(account.balance, account?.decimals || 8)} {account.currency_code}
                  </p>

                  <p className="whitespace-nowrap text-[11px] font-normal leading-[16.5px] text-text-secondary">
                    {/* {account.usdLabel} */}
                  </p>

                  <PercentChange
                    value={account.last_24hr_change ?? 0}
                    positive={account.last_24hr_change > 0}
                  />
                </div>
              </li>
          ))}
        </ul>
      </Card>

      <YourAccountsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};



export default YourAccounts;

